import React from 'react';
import { Grid } from 'semantic-ui-react';
import { withRouter, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './organization.css'


const MyOrganization = ({
	corporateList,
	history
}) => {
	console.log("CORPORATE LIST COMING THROUGH THE CONTAINER ------>>>>>", corporateList)


	const handleClick = (item) => {
		localStorage.setItem('activeItem', item.corporateId);
		localStorage.setItem('activeOrganization', item.corporateName);
		// console.log('THE DATA WE ARE GETTING FROM ON-CLICK IS ----->>>>>', item);
		history.push('/myorganization/active-user');
	}

	return (
		<Grid padded style={{ marginTop: '0px', padding: '10vh' }}>
			<Helmet>
				<title>Select Your Organization</title>
			</Helmet>
			<Grid.Row>
				<Grid.Column width={4} textAlign="center">
					<h2
						style={{
							fontWeight: 400,
							textAlign: 'left',
							color: '#000',
							padding: '0.5em',
							fontSize: '22px'
						}}
					>
						Select Your Organization
        </h2>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column width={4} textAlign="center">
					<h2
						style={{
							fontWeight: 400,
							textAlign: 'left',
							color: '#555',
							padding: '0.5em'
						}}
					>
						<div className='organizationContainer'>

							<div className='headingWrapper'>
								<div className='textMain'>
									<div className='headingText'>ID</div>
								</div>
								<div className='textMain'>
									<div className='headingText'>Name</div>
								</div>
							</div>

							<div>
								{corporateList && (
									corporateList.map((item) => {
										return (
											<div className='headingWrapper'>
												<div className='textMain'>
													<div className='dataText' onClick={() => handleClick(item)}>{item.corporateId}</div>
												</div>
												<div className='textMain'>
													<div className='dataText' onClick={() => handleClick(item)} >{item.corporateName}</div>
												</div>
											</div>
										)
									})
								)}
							</div>
						</div>
					</h2>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default withRouter(MyOrganization);



// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/component.jsx